import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-rule-edit"
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionSwitchPromptTitle'),
      "open": _vm.conditionSwitchPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionSwitchPromptButton'),
        color: _vm.color,
        emit: 'switch-parser'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.conditionsTab = `tab-${_vm.otherConditionType}`;
        _vm.conditionSwitchPrompt = false;
      },
      "switch-parser": function ($event) {
        _vm.rule.properties.conditionType = _vm.currentConditionType;
        _vm.setConditionsTab();
        _vm.conditionSwitchPrompt = false;
      }
    }
  }, [_vm.conditionSwitchPrompt ? [_vm._v(_vm._s(_vm.conditionSwitchPromptText))] : _vm._e()], 2), !_vm.rule.properties.timeTriggerOnly && _vm.stateMetrics.filter(s => !!s.key).length === 0 ? _c(VAlert, {
    staticClass: "mb-1",
    attrs: {
      "value": true,
      "color": "transparent",
      "icon": "fal fa-comment-exclamation"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.noConditions')) + "\n    ")]) : !_vm.rule.properties.timeTriggerOnly ? _c(VTabs, {
    staticClass: "px-1",
    model: {
      value: _vm.conditionsTab,
      callback: function ($$v) {
        _vm.conditionsTab = $$v;
      },
      expression: "conditionsTab"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-tree"
    },
    on: {
      "click": function ($event) {
        _vm.conditionSwitchPrompt = true;
      }
    }
  }, [_c(VCheckbox, {
    attrs: {
      "input-value": _vm.conditionsTab === 'tab-tree',
      "color": _vm.color
    }
  }), _c(VIcon, {
    staticClass: "mr-2"
  }, [_vm._v("fal fa-code-merge")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionsTree')) + "\n      ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-script"
    },
    on: {
      "click": function ($event) {
        _vm.conditionSwitchPrompt = true;
      }
    }
  }, [_c(VCheckbox, {
    attrs: {
      "input-value": _vm.conditionsTab === 'tab-script',
      "color": _vm.color
    }
  }), _c(VIcon, {
    staticClass: "mr-2"
  }, [_vm._v("fal fa-code")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionsScript')) + "\n      ")], 1), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.conditionsTab,
      callback: function ($$v) {
        _vm.conditionsTab = $$v;
      },
      expression: "conditionsTab"
    }
  }, [_c(VTabItem, {
    key: "tree",
    staticClass: "pt-3",
    attrs: {
      "value": "tab-tree"
    }
  }, [_c('core-dtwin-rule-edit-conditions', {
    attrs: {
      "disabled": _vm.disabled,
      "isCreatedByTemplate": _vm.isCreatedByTemplate,
      "templateContext": _vm.templateContext,
      "rule": _vm.rule,
      "states": _vm.states,
      "conditionIndicies": []
    },
    on: {
      "conditions-changed": _vm.convertToJavascript
    }
  })], 1), _c(VTabItem, {
    key: "script",
    staticClass: "pt-3",
    attrs: {
      "value": "tab-script"
    }
  }, [_vm.firstStateMetric && _vm.conditionsTab === 'tab-script' ? _c('div', [_c('p', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionsSampleText', {
        metric: _vm.firstStateMetric
      }))
    }
  }), _c('div', [_c('pre', {
    staticClass: "my-3 codefield"
  }, [_vm._v("const currentDate = new Date(new Date().toLocaleString('en-US', {timeZone: 'Europe/Berlin'}));\nreturn " + _vm._s(_vm.firstStateMetric) + " >= 20 && (currentDate.getHours() >= 21 || currentDate.getHours() <= 7);")])]), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionsMoreLinkText')) + ":\n              "), _c('a', {
    attrs: {
      "href": "https://gitlab.com/digimondo-samples/twin-rule-samples/",
      "target": "_blank"
    }
  }, [_vm._v("\n                » DIGIMONDO Code Samples (gitlab.com)\n              ")])]), _c('code', [_vm._v(_vm._s(_vm.metricsPreview))]), _c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-3",
    style: _vm.scriptSyntaxError ? 'border: 2px solid red; border-width: 0 2px' : '',
    attrs: {
      "options": _vm.cmOptions
    },
    on: {
      "focus": _vm.onCmFocus
    },
    model: {
      value: _vm.rule.properties.conditionScript,
      callback: function ($$v) {
        _vm.$set(_vm.rule.properties, "conditionScript", $$v);
      },
      expression: "rule.properties.conditionScript"
    }
  }), _c('code', [_vm._v("}")]), _vm.scriptSyntaxError !== 0 ? _c('div', [_vm.scriptSyntaxError ? _c('pre', {
    staticClass: "my-3 codefield danger--text"
  }, [_vm._v("Error: " + _vm._s(_vm.scriptSyntaxError))]) : _c('p', {
    staticClass: "mt-3 description"
  }, [_c(VIcon, {
    attrs: {
      "color": "green",
      "small": ""
    }
  }, [_vm._v("fal fa-check-circle")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionScriptResultOk')) + "\n              ")], 1)]) : _vm._e(), _c('div', {
    staticClass: "text-right"
  }, [!_vm.isMobile ? _c('span', [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": _vm.evaluateConditionScript
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fal fa-rocket")]), _vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionScriptTest')) + "\n                ")], 1)], 1) : _c('span', [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.color,
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": _vm.evaluateConditionScript
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-rocket")])], 1)], 1)])], 1) : _vm._e()])], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };